@file:OptIn(InternalResourceApi::class)

package finglish.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.RegionQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/finglish.composeapp.generated.resources/"

@delegate:ResourceContentHash(1_582_256_261)
internal val Res.string.action_clear: StringResource by lazy {
      StringResource("string:action_clear", "action_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 10, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 28),
      ))
    }

@delegate:ResourceContentHash(-969_901_494)
internal val Res.string.action_copy: StringResource by lazy {
      StringResource("string:action_copy", "action_copy", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 55, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 39, 27),
      ))
    }

@delegate:ResourceContentHash(-372_458_656)
internal val Res.string.action_more_options: StringResource by lazy {
      StringResource("string:action_more_options", "action_more_options", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 83, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 67, 43),
      ))
    }

@delegate:ResourceContentHash(-1_224_471_840)
internal val Res.string.action_paste: StringResource by lazy {
      StringResource("string:action_paste", "action_paste", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 151, 40),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 111, 28),
      ))
    }

@delegate:ResourceContentHash(1_992_073_386)
internal val Res.string.action_settings: StringResource by lazy {
      StringResource("string:action_settings", "action_settings", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 192, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 140, 35),
      ))
    }

@delegate:ResourceContentHash(386_149_589)
internal val Res.string.action_share: StringResource by lazy {
      StringResource("string:action_share", "action_share", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 236, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 176, 28),
      ))
    }

@delegate:ResourceContentHash(1_092_742_156)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 293, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 205, 28),
      ))
    }

@delegate:ResourceContentHash(1_120_137_272)
internal val Res.string.error_something_wrong: StringResource by lazy {
      StringResource("string:error_something_wrong", "error_something_wrong", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 330, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 234, 57),
      ))
    }

@delegate:ResourceContentHash(-2_128_648_527)
internal val Res.string.label_beta: StringResource by lazy {
      StringResource("string:label_beta", "label_beta", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 392, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 292, 26),
      ))
    }

@delegate:ResourceContentHash(-2_035_141_771)
internal val Res.string.settings_app_version: StringResource by lazy {
      StringResource("string:settings_app_version", "settings_app_version", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 319, 40),
      ))
    }

@delegate:ResourceContentHash(-1_302_705_266)
internal val Res.string.settings_dynamic_colors: StringResource by lazy {
      StringResource("string:settings_dynamic_colors", "settings_dynamic_colors", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 431, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 360, 51),
      ))
    }

@delegate:ResourceContentHash(-1_839_249_415)
internal val Res.string.settings_language: StringResource by lazy {
      StringResource("string:settings_language", "settings_language", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 499, 37),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 498, 37),
      ))
    }

@delegate:ResourceContentHash(-2_005_328_783)
internal val Res.string.settings_language_en: StringResource by lazy {
      StringResource("string:settings_language_en", "settings_language_en", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 412, 40),
      ))
    }

@delegate:ResourceContentHash(-2_131_162_797)
internal val Res.string.settings_language_fa: StringResource by lazy {
      StringResource("string:settings_language_fa", "settings_language_fa", setOf(
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 453, 44),
      ))
    }

@delegate:ResourceContentHash(1_430_553_337)
internal val Res.string.settings_theme: StringResource by lazy {
      StringResource("string:settings_theme", "settings_theme", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 655, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 642, 30),
      ))
    }

@delegate:ResourceContentHash(1_285_479_907)
internal val Res.string.settings_theme_day: StringResource by lazy {
      StringResource("string:settings_theme_day", "settings_theme_day", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 537, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 536, 30),
      ))
    }

@delegate:ResourceContentHash(543_767_071)
internal val Res.string.settings_theme_night: StringResource by lazy {
      StringResource("string:settings_theme_night", "settings_theme_night", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 572, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 567, 36),
      ))
    }

@delegate:ResourceContentHash(1_927_647_732)
internal val Res.string.settings_theme_system: StringResource by lazy {
      StringResource("string:settings_theme_system", "settings_theme_system", setOf(
        ResourceItem(setOf(LanguageQualifier("fa"), RegionQualifier("IR"), ), "${MD}values-fa-rIR/strings.commonMain.cvr", 609, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 604, 37),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_clear", Res.string.action_clear)
  map.put("action_copy", Res.string.action_copy)
  map.put("action_more_options", Res.string.action_more_options)
  map.put("action_paste", Res.string.action_paste)
  map.put("action_settings", Res.string.action_settings)
  map.put("action_share", Res.string.action_share)
  map.put("app_name", Res.string.app_name)
  map.put("error_something_wrong", Res.string.error_something_wrong)
  map.put("label_beta", Res.string.label_beta)
  map.put("settings_app_version", Res.string.settings_app_version)
  map.put("settings_dynamic_colors", Res.string.settings_dynamic_colors)
  map.put("settings_language", Res.string.settings_language)
  map.put("settings_language_en", Res.string.settings_language_en)
  map.put("settings_language_fa", Res.string.settings_language_fa)
  map.put("settings_theme", Res.string.settings_theme)
  map.put("settings_theme_day", Res.string.settings_theme_day)
  map.put("settings_theme_night", Res.string.settings_theme_night)
  map.put("settings_theme_system", Res.string.settings_theme_system)
}
